import { render, staticRenderFns } from "./OutOfStockAlert.vue?vue&type=template&id=d8e9d494"
import script from "./OutOfStockAlert.vue?vue&type=script&lang=js"
export * from "./OutOfStockAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports